import { render, staticRenderFns } from "./HoldsListComponent.vue?vue&type=template&id=482ac4b0"
import script from "./HoldsListComponent.vue?vue&type=script&lang=js"
export * from "./HoldsListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports